import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const DemandOrganizationService = {
    list: async () => axios.post(API_URL + "/demands-boards/list").then(({data}) => data),
    getUserOptions: async () => axios.get(API_URL + "/demands-boards/users/options").then(({data}) => data),
    getById: async id => axios.get(API_URL + "/demands-boards/" + id).then(({data}) => data),
    getMembers: async id => axios.get(API_URL + "/demands-boards/" + id + "/members").then(({data}) => data),
    create: async model => axios.post(API_URL + "/demands-boards", model).then(({data}) => data),
    edit: async (model, id) => axios.post(API_URL + "/demands-boards/" + id, {...model, _method: "PUT"}).then(({data}) => data),
    updateContent: async (content, id) => axios.post(API_URL + "/demands-boards/" + id + "/content", content).then(({data}) => data),
    updateLabels: async (labels, id) => axios.patch(API_URL + "/demands-boards/" + id + "/labels", {labels}).then(({data}) => data),
    updateCardDetails: async (cardReference, changes, id) => {
        if (!Object.prototype.hasOwnProperty.call(changes, "attachments")) {
            return axios.patch(API_URL + "/demands-boards/" + id + "/cards/" + encodeURIComponent(cardReference) + "/details", changes).then(({data}) => data);
        }

        const formData = new FormData();
        Object.entries(changes).forEach(([field, value]) => {
            if (field === "attachments") {
                const attachments = value.map(({file, ...attachment}) => {
                    if (file) formData.append("attaches[]", file);
                    return attachment;
                });
                formData.append(field, JSON.stringify(attachments));
                return;
            }

            formData.append(field, typeof value === "object" ? JSON.stringify(value) : value ?? "");
        });
        formData.append("_method", "PATCH");

        return axios.post(API_URL + "/demands-boards/" + id + "/cards/" + encodeURIComponent(cardReference) + "/details", formData).then(({data}) => data);
    },
    createCardComment: async (id, cardReference, text) => axios.post(API_URL + "/demands-boards/" + id + "/cards/" + encodeURIComponent(cardReference) + "/comments", {text}).then(({data}) => data),
    updateCardComment: async (id, cardReference, commentId, text) => axios.patch(API_URL + "/demands-boards/" + id + "/cards/" + encodeURIComponent(cardReference) + "/comments/" + commentId, {text}).then(({data}) => data),
    deleteCardComment: async (id, cardReference, commentId) => axios.delete(API_URL + "/demands-boards/" + id + "/cards/" + encodeURIComponent(cardReference) + "/comments/" + commentId).then(({data}) => data),
    startEditing: async id => axios.post(API_URL + "/demands-boards/" + id + "/editing").then(({data}) => data),
    stopEditing: async id => axios.delete(API_URL + "/demands-boards/" + id + "/editing").then(({data}) => data),
    copy: async id => axios.post(API_URL + "/demands-boards/" + id + "/copy").then(({data}) => data),
    delete: async id => axios.delete(API_URL + "/demands-boards/" + id).then(({data}) => data),
};

export default DemandOrganizationService;
